module.exports = __webpack_public_path__ + "static/media/lumin-bottles-on-round-stone.e46af0a0.jpg";